module.exports = __webpack_public_path__ + "img/delta.5deee3bd.avif";